import { render } from "./SetaEsquerda.vue?vue&type=template&id=4ea12fc8"
const script = {}
script.render = render

export default script